import api, {handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'superDataVisualizations/FETCH_REQUEST'
const FETCH_SUCCESS = 'superDataVisualizations/FETCH_SUCCESS'
const FETCH_FAILURE = 'superDataVisualizations/FETCH_FAILURE'
const UPDATE_REQUEST = 'superDataVisualizations/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'superDataVisualizations/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'superDataVisualizations/UPDATE_FAILURE'
const RESET_REQUEST = 'superDataVisualizations/RESET_REQUEST'
const RESET_SUCCESS = 'superDataVisualizations/RESET_SUCCESS'
const RESET_FAILURE = 'superDataVisualizations/RESET_FAILURE'

const initialState = {
  result: {
    data: {
      chart: [],
      chart_categories: [],
      table: [],
      total: 0
    },
    filters: [],
    positions: [],
    director_positions: [],
    sectors: [],
    min_market_caps: [],
    max_market_caps: [],
    min_totals: [],
    max_totals: [],
    min_total_assets: [],
    max_total_assets: [],
    min_revenues: [],
    max_revenues: []
  },
  loading: false,
  loaded: false,
  updating: false,
  updated: false,
  resetting: false,
  resetDone: false,
  errors: {}
}

export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function updateRequest() {
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(payload) {
  return {
    type: UPDATE_SUCCESS,
    payload,
  }
}

export function updateFailure(errors) {
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function resetRequest() {
  return {
    type: RESET_REQUEST,
  }
}

export function resetSuccess(payload) {
  return {
    type: RESET_SUCCESS,
    payload,
  }
}

export function resetFailure(errors) {
  return {
    type: RESET_FAILURE,
    errors,
  }
}

export function loadVisuals() {
  return (dispatch) => {
    dispatch(fetchRequest())

    return api(`api/v1/data_visualizations/superannuation`)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })
  }
}

export function updateVisuals(id, options = {}, cb= null) {
  options.data_visualizations.code = "super_remuneration"
  const config = {
    method: 'PATCH',
    body: JSON.stringify(options)
  }

  return (dispatch) => {
    dispatch(updateRequest())

    return api(`api/v1/data_visualizations/${id}`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(updateSuccess(json))

        if(cb) cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(updateFailure(errors))
        })
      })
  }
}

export function resetVisuals(cb) {
  return (dispatch) => {
    dispatch(resetRequest())

    return api(`api/v1/data_visualizations/reset_filters`, {data_visualizations: {code: "super_remuneration"}})
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(resetSuccess(json))
        if(cb) cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(resetFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload
      })
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        result: {
          ...state.result
        },
        errors: errors
      }
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        updated: true,
        errors: [],
        result: Object.assign({}, {...state.result, filters: Object.assign([], payload.filters) })
      })
    case UPDATE_FAILURE:
      return {
        ...state,
        errors: errors,
        updating: false,
        updated: false,
        result: {
          ...state.result
        }
      }
    case RESET_REQUEST:
      return Object.assign({}, state, {
        resetting: true
      })
    case RESET_SUCCESS:
      return Object.assign({}, state, {
        resetting: false,
        resetDone: true,
        errors: [],
        result: Object.assign({}, {...state.result, filters: Object.assign([], payload.filters) })
      })
    case RESET_FAILURE:
      return {
        ...state,
        errors: errors,
        resetting: false,
        resetDone: false,
        result: {
          ...state.result
        }
      }
    default:
      return state
  }
}

